const MuteIcon = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.9081 15.0919L19.0007 12M19.0007 12L22.0919 8.90807M19.0007 12L15.9081 8.90807M19.0007 12L22.0919 15.0919M2 9.99999V14C2 14.5523 2.44772 15 3 15H5.69722C5.89465 15 6.08766 15.0584 6.25192 15.1679L10.4453 17.9635C11.1099 18.4066 12 17.9302 12 17.1315V6.8685C12 6.06981 11.1099 5.59342 10.4453 6.03645L6.25192 8.83204C6.08766 8.94155 5.89465 8.99999 5.69722 8.99999H3C2.44772 8.99999 2 9.4477 2 9.99999Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MuteIcon;
